@if(displayAs === 'profile') {
<div class="profile-upload d-flex align-items-center gap-3">
  <div class="profile-avatar position-relative border-radius-50 d-flex justify-content-center align-items-center overflow-hidden cursor-pointer" role="button" tabindex="0">
    <img *ngIf="documents.length > 0 && documents[0]?.MimeType?.startsWith('image/')" [src]="documents[0].Base64" alt="Profile Picture" class="w-100 h-100 object-fit-cover" />

    <div *ngIf="documents.length === 0" class="default-icon fs-48 font-gray">
      <i class="fa fa-user"></i>
    </div>

    <span
      *ngIf="documents.length > 0"
      class="remove-icon position-absolute font-white border-radius-50 d-flex align-items-center justify-content-center fs-16 cursor-pointer"
      role="button"
      tabindex="0"
      (click)="removeFile(documents[0]); $event.stopPropagation()"
      (keydown)="removeFile(documents[0]); $event.stopPropagation()"
      >&times;</span
    >
  </div>

  <div>
    <label [for]="category + '-upload'" class="upload-link fs-14 fw-medium cursor-pointer d-inline-flex align-items-center gap-2"> <i class="fa fa-cloud-upload"></i> Upload Picture </label>
    <input type="file" [id]="category + '-upload'" hidden (change)="onFileSelected($event)" [accept]="displayAs === 'profile' ? 'image/jpeg,image/png,image/jpg,image/gif' : '*/*'" />
  </div>
</div>
} @if(displayAs === 'default') {
<div class="d-flex mt-4">
  <div class="fs-14 fw-bold mb-3 font-white">{{ label }}</div>
  <div [innerHtml]="SVG_ICONS.HR_LINE() | sanitizer : 'html'" class="ms-4 svg-line"></div>
</div>
<label [for]="category + '-upload'" class="fs-14 fw-normal font-white mb-2">PDF, PNG, JPG, JPEG (Max Size: 2MB)</label>

<div class="d-flex gap-2 mt-2 align-items-start flex-wrap">
  @for(doc of documents; track doc.FileName){
  <div class="d-flex flex-column align-items-center">
    <div
      class="preview-box d-flex justify-content-center align-items-center border-radius-10 bg-form-control position-relative cursor-pointer overflow-hidden"
      role="button"
      tabindex="0"
      (click)="openFile(doc)"
      (keydown)="openFile(doc)">
      <span
        class="remove-icon position-absolute font-white border-radius-50 d-flex align-items-center justify-content-center fs-16 cursor-pointer"
        role="button"
        tabindex="0"
        (click)="removeFile(doc); $event.stopPropagation()"
        (keydown)="removeFile(doc); $event.stopPropagation()"
        >&times;</span
      >

      <img *ngIf="doc?.MimeType?.startsWith('image/')" [src]="doc.Base64" class="preview-img w-100 h-100 object-fit-cover" [alt]="label + ' preview'" />

      <div *ngIf="!doc?.MimeType?.startsWith('image/')" class="checkmark fs-40 font-green">&#10003;</div>
    </div>
    <small class="file-name fs-12 font-white mt-2 overflow-hidden text-overflow-ellipsis text-center" [title]="doc.FileName"> {{ doc.FileName | slice : 0 : 15 }}... </small>
  </div>
  }

  <div class="d-flex flex-column">
    <input type="file" [id]="category + '-upload'" hidden (change)="onFileSelected($event)" [accept]="acceptTypes" multiple />
    <label [for]="category + '-upload'" class="upload-box border-radius-10 d-flex align-items-center justify-content-center flex-column gap-2 cursor-pointer fw-medium fs-14">
      <div [innerHtml]="SVG_ICONS.UPLOAD_ICON() | sanitizer : 'html'"></div>
      <span>UPLOAD</span>
    </label>
  </div>
</div>
}
